export default [
  {
    content: "• 사용 기계·기구·설비 방호조치",
    isChecked: "",
  },
  {
    content: "• 작업구역 설정(출입경고 표지)",
    isChecked: "",
  },
  {
    content: "• 인화성액체 사용시 소화기 비치",
    isChecked: "",
  },
  {
    content: "• 화기작업시 인화물질 제거",
    isChecked: "",
  },
  {
    content: "• 화기작업시 불꽃방지막 사용",
    isChecked: "",
  },
  {
    content: "• 보호구 착용",
    isChecked: "",
  },
  {
    content: "• 안전교육",
    isChecked: "",
  },
  {
    content: "• 외부인 접근금지 조치",
    isChecked: "",
  },
  {
    content: "• 정전조치시 잠금 및 표지부착",
    isChecked: "",
  },
  {
    content: "• 조명장비  ",
    isChecked: "",
  },
];
